import {
  InvoiceRecipientsDrawer,
  FilesReportsNavigation,
  InvoicingTable,
} from '@pages/files-reports/containers';
import { HasPermission } from '@shared/components';
import { useState } from 'react';

export interface SelectedInvoice {
  invoiceName: string;
  invoiceId: string;
}

export const Invoicing = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<SelectedInvoice | null>(null);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedInvoice(null);
  };

  return (
    <HasPermission
      permissionFeature="REPORTS_FILES_INVOICING"
      permissionType="READ"
      redirect={true}
    >
      <div className="flex justify-between mb-4">
        <FilesReportsNavigation />
      </div>

      <InvoicingTable />

      <InvoiceRecipientsDrawer
        invoiceName={selectedInvoice?.invoiceName ?? ''}
        invoiceId={selectedInvoice?.invoiceId ?? ''}
        onClose={handleCloseDrawer}
        open={isDrawerOpen}
      />
    </HasPermission>
  );
};
